import React, { useState, useEffect } from 'react';
import { Typography, Row, Col } from 'antd';
import Image from '../images/banner_carousel.webp';
import '../styles/NuestraFe.css';

const { Title, Text } = Typography;

const NuestraFe = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensure the page takes up the full viewport height
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1 }}>
        {/* Banner */}
        <div
          style={{
            width: '100%',
            height: '300px',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${Image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Title
            level={1}
            style={{
              color: 'white',
              fontSize: '48px',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
              fontFamily: 'Outfit',
            }}
          >
            {isMobile ? 'Conoce nuestra fe' : 'Nuestra fe'}
          </Title>
        </div>

        {/* Content */}
        <div style={{ padding: '40px' }}>
          <Row gutter={64} align="middle">
            {/* Left Column */}
            <Col xs={24} md={12} style={{ marginBottom: 15 }}>
              <Title
                level={2}
                className="hide-on-mobile"
                style={{
                  fontSize: '40px',
                  fontFamily: 'Outfit',
                  color: 'rgba(0, 0, 0, 0.85)',
                }}
              >
                Conoce nuestra fe
              </Title>
              <Text
                style={{
                  fontSize: '20px',
                  lineHeight: '1.8',
                  fontFamily: 'Roboto',
                  color: 'rgba(0, 0, 0, 0.85)',
                }}
              >
                Por cuanto Dios nos salvó por medio de Jesucristo para ser
                testigos y predicar el evangelio del Reino de los Cielos del
                cual somos herederos.Hoy, en el cumplimiento de los tiempos, nos
                levantamos a conquistar lo que recibimos por herencia y
                avanzamos hasta lo último de la tierra; haciendo discípulos y
                consolidándolos como padres espirituales hasta que alcancen el
                propósito eterno. Somos un ejército de reyes y sacerdotes que
                trabaja como equipo unido por el amor de Dios.Estamos decididos
                a perseverar con esfuerzo y valor, dispuestos a pagar el precio
                porque la guerra es del Señor y el botín es nuestro. Nos gozamos
                en la victoria cuando repartimos todo lo que despojamos al
                enemigo.Dios desarrolló nuestro carácter y llegamos a ser lo que
                Él quiso que fuéramos cuando diseñó nuestros días. El enemigo
                fue a parar debajo de nuestros pies y comenzamos a tomar
                posesión de lo que nos pertenece por decreto divino.
              </Text>
            </Col>

            {/* Right Column */}
            <Col xs={24} md={12}>
              <iframe
                width="100%"
                height="500"
                src="https://www.youtube.com/embed/DpPe9tnM3q8" // Replace with your YouTube video URL
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default NuestraFe;
